import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AppShell from './components/AppShell';
import { ScanSessionProvider } from './features/scanner/ScanSessionContext';
import HomePage from './pages/HomePage';
import ScannerPage from './pages/ScannerPage';
import ImagePreviewPage from './pages/ImagePreviewPage';
import ProcessingPage from './pages/ProcessingPage';
import ReviewPage from './pages/ReviewPage';
import HistoryPage from './pages/HistoryPage';
import HistoryDetailPage from './pages/HistoryDetailPage';
import SettingsPage from './pages/SettingsPage';
import IrdAssistPage from './pages/IrdAssistPage';

export default function App() {
  return (
    <ScanSessionProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<HomePage />} />
            <Route path="scan" element={<ScannerPage />} />
            <Route path="scan/preview" element={<ImagePreviewPage />} />
            <Route path="scan/processing" element={<ProcessingPage />} />
            <Route path="review" element={<ReviewPage />} />
            <Route path="history" element={<HistoryPage />} />
            <Route path="history/:billId" element={<HistoryDetailPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="ird/:billId" element={<IrdAssistPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ScanSessionProvider>
  );
}
